import React from "react";
import HKPProductInventoryPicker, { AddResult } from "../../components/products/HKPProductInventoryPicker";
import { PickerProduct } from "../../components/products/productSelection";
import { loadSalesProductPage } from "./salesProductSelection";
import { SalesScanIcons, SalesScanStage, useSalesScanner } from "./SalesScanPad";

function Scanner({ locate, disabled }: { locate: (value: string) => void; disabled: boolean }) {
  const scan = useSalesScanner(locate, disabled);
  return <div className="hkp-product-picker__scanner"><SalesScanIcons scan={scan} /><SalesScanStage scan={scan} /></div>;
}
export default function SalesInventoryPicker(props: {
  addedIds: string[]; initialExact?: string; busy: boolean; progress: string; feedback: React.ReactNode;
  onAdd: (products: PickerProduct[]) => Promise<AddResult>; onDone: () => void;
}) {
  return <HKPProductInventoryPicker {...props} loadPage={loadSalesProductPage}
    renderScanner={(locate, disabled) => <Scanner locate={locate} disabled={disabled} />} />;
}
